module.exports = __webpack_public_path__ + "img/centrum-cocktailkaart-full.3e722a68.jpg";